.CurrentTimeIndicator {
    position: absolute;
    left: var(--Week__stepWidth--s);
    right: 0;
    height: 0;
    border-top: 1px dashed var(--soniq-t--global--border--color--accent--today--default);
    pointer-events: none;
    z-index: 2;

    @media (min-width: 900px) {
        left: var(--Week__stepWidth--m);
    }
}

.CurrentTimeIndicator::before {
    content: '';
    position: absolute;
    top: -4px;
    left: -4px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: var(--soniq-t--global--border--color--accent--today--default);
}
